/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     费用中心-账单管理 API 接口
  | @Version:   2018-12-27  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getBillListApi(query) {
  return request({
    url: '?c=expense&a=order-bill&do=list',
    method: 'get',
    params: query
  })
}

export function getBillDetailApi(billid) {
  return request({
    url: '?c=expense&a=order-bill&do=get',
    method: 'get',
    params: { billid }
  })
}

export function buildBillApi(formData) {
  return request({
    url: '?c=expense&a=order-bill&do=build',
    method: 'post',
    data: formData
  })
}

export function confirmBillApi(formData) {
  return request({
    url: '?c=expense&a=order-bill&do=confirm',
    method: 'post',
    data: formData
  })
}

export function billFlowApi(data) {
  return request({
    url: '?c=expense&a=flow&do=list',
    method: 'get',
    params: data
  })
}
